import IconEducation from '@apollo/icons/default/IconEducation.svg';
import {
  Admonition,
  AdmonitionBody,
  AdmonitionHeader,
  AdmonitionTitle,
  Button,
} from '@apollo/orbit';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { OnboardingStepReachedProperties } from 'src/lib/analytics/amplitude/vendor';

import { useTrackOnboardingStep } from '../../../hooks/useTrackOnboardingStep';

interface Props {
  header: string;
  subHeader?: string;
  stepId: OnboardingStepReachedProperties['Step'];
  progressionButton: React.ReactNode;
  educationalContent?: React.ReactNode;
  children?: React.ReactNode;
}

export const FormStepLayout = ({
  header,
  subHeader,
  stepId,
  educationalContent,
  progressionButton,
  children,
}: Props) => {
  const history = useHistory();

  useTrackOnboardingStep(stepId);

  return (
    <div className="flex h-full flex-col items-stretch justify-center gap-8 text-black">
      <div className="flex flex-col gap-2">
        <h2 className="text-center font-semibold sm:text-4xl">{header}</h2>
        {subHeader && (
          <h3 className="text-center font-normal sm:text-lg">{subHeader}</h3>
        )}
      </div>
      <div className="rounded border border-primary bg-silver-lighter p-6">
        {children}
      </div>
      {educationalContent && (
        <Admonition variant="neutral">
          <AdmonitionHeader icon={IconEducation}>
            <AdmonitionTitle>Tip</AdmonitionTitle>
          </AdmonitionHeader>
          <AdmonitionBody>{educationalContent}</AdmonitionBody>
        </Admonition>
      )}
      <div className="flex flex-row justify-end gap-4 self-end pb-4">
        <Button onClick={history.goBack} variant="secondary">
          Go back
        </Button>
        {progressionButton}
      </div>
    </div>
  );
};
